var map = {
	"./Fighting Idle.fbx": "943c",
	"./Idle Boxing 1.fbx": "690e",
	"./Idle Boxing 2.fbx": "c53a",
	"./Idle Boxing 4.fbx": "c90e",
	"./Idle aiming.fbx": "ca73",
	"./Kneeling Down.fbx": "73b8",
	"./Mma Idle.fbx": "09ab",
	"./Pistol Idle.fbx": "be49",
	"./Quick Formal Bow.fbx": "6b3a",
	"./Quick Informal Bow.fbx": "2bb9",
	"./Taunt (1).fbx": "890c",
	"./Taunt.fbx": "dab8",
	"./a1-Victory.fbx": "794a",
	"./a2-Defeat.fbx": "5fb8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a79a";